import { render, staticRenderFns } from "./StudyMenu.vue?vue&type=template&id=72e6c7c0&scoped=true&"
import script from "./StudyMenu.vue?vue&type=script&lang=js&"
export * from "./StudyMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e6c7c0",
  null
  
)

export default component.exports